// extracted by css-extract-rspack-plugin
export default {"unavailable":"_cf96ebd2","bold":"_40b8fb75","tokenIdLabel":"_d9d80240"};